import { HubConnectionBuilder,HubConnection, HttpTransportType } from "@microsoft/signalr";



class SignalRService {
    connection: HubConnection;
  constructor() {
    
    this.connection = new HubConnectionBuilder()
      .withUrl("https://whatsapp.superbit.co.il/whatsapphub",{skipNegotiation:true,transport:HttpTransportType.WebSockets})
      .build();

      console.log("Websocket 1");

    this.connection.start().then(() => {
        
        console.log('SignalR connected');
        this.connection.on('UserConnected', message => {
          
        });


        

        this.connection.invoke("SaveUserId", this.getUserId());
      }).catch((error) =>{
      console.log("Websocket error");
      console.error("Websocket: "+error)
    }
    );

    
  }
  
  getUserId(){

    const parsedData = localStorage.getItem('loggedUser');
        if (parsedData) {
          const loggedUser = JSON.parse(parsedData)
          return loggedUser.id;
        }
        return "";
  }
  
  
  // Add methods for sending and receiving messages/events
}

export default SignalRService;